import React from 'react';
import type { Message } from '../../types';

interface StreamingMessageProps {
  message: Message;
}

const StreamingMessage = React.memo(function StreamingMessage({ message }: StreamingMessageProps) {
  return (
    <div className="flex items-start mb-4">
      <div className="max-w-[80%] rounded-2xl px-4 py-2 border shadow bg-white border-gray-200">
        <p className="text-sm" style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
          {message.text}
          <span
            className="inline-block w-1 h-4 bg-blue-600 ml-1 animate-pulse"
            aria-hidden="true"
          />
        </p>
      </div>
    </div>
  );
});

export default StreamingMessage;
